import { render, staticRenderFns } from "./SelfRegistiration.vue?vue&type=template&id=bc90c526&scoped=true"
import script from "./SelfRegistiration.vue?vue&type=script&lang=js"
export * from "./SelfRegistiration.vue?vue&type=script&lang=js"
import style0 from "./SelfRegistiration.vue?vue&type=style&index=0&id=bc90c526&prod&scoped=true&lang=css"
import style1 from "./SelfRegistiration.vue?vue&type=style&index=1&id=bc90c526&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc90c526",
  null
  
)

export default component.exports